import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import Fire, { firebaseAuth } from '../../../config/Fire';
import { BrowserRouter as Router, Route, Redirect } from 'react-router-dom';
import GoogleButton from 'react-google-button';
import { Loading, Header, modalStyles } from './../../common';
import { signInWithGoogle, authenticateSuccess, activeUser } from './../../../actions/AuthActions';
import './Login.css';

class Login extends Component {
	constructor(props) {
		super(props);
		this.state = {
			modal: true,
		};
		this.handleModalClose = this.handleModalClose.bind(this);
		this.refUser = Fire.firestore().collection('users');
		this.unsubscribeUser = null;
	}

	componentDidMount() {
		firebaseAuth().onAuthStateChanged(user => {
			if (user) {
				this.unsubscribeUser = this.refUser
					.doc(user.uid)
					.onSnapshot(this.onUserCollectionUpdate, function(_e) {
						console.log('_e', _e);
					});
			}
		});
	}

	componentWillUnmount() {}

	onUserCollectionUpdate = userSnapshot => {
		if (typeof userSnapshot.data() === 'undefined') {
			return null;
		}
		if (typeof userSnapshot.data().active === 'undefined') {
			return null;
		}
		return this.props._activeUser(userSnapshot.data());
	};

	handleModalClose() {
		return null;
	}

	_loading() {
		return null;
	}

	render() {
		if (this.props.auth.signedIn && !this.props.auth.active) {
			return (
				<Redirect
					to={{
						pathname: '/',
						state: { from: '/login_out' },
					}}
				/>
			);
		}
		if (!this.props.auth.signedIn && this.props.auth.active) {
			return <Loading />;
		}
		if (this.props.auth.signedIn && this.props.auth.active) {
			return (
				<Redirect
					to={{
						pathname: '/',
						state: { from: '/login' },
					}}
				/>
			);
		}
		return (
			<div className="Home">
				<Header />
				<ReactModal
					isOpen={this.state.modal}
					onRequestClose={this.handleModalClose}
					style={modalStyles}
					ariaHideApp={false}
					contentLabel="Confirm">
					<GoogleButton
						onClick={() => {
							this.props._signIn();
						}}
					/>
				</ReactModal>
			</div>
		);
	}
}

const mapStateToProps = ({ auth }) => {
	return {
		auth,
	};
};

const mapDispatchToProps = dispatch => ({
	_signIn: () => dispatch(signInWithGoogle()),
	_authenticateSuccess: user => dispatch(authenticateSuccess(user)),
	_activeUser: user => dispatch(activeUser(user)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(Login);



// WEBPACK FOOTER //
// ./src/components/screens/login/Login.js